import script from "./StopCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StopCard.vue?vue&type=script&setup=true&lang=js"

import "./StopCard.vue?vue&type=style&index=0&id=201fc123&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201fc123"]])

export default __exports__